module.exports = __webpack_public_path__ + "img/mask-image-right.9fb48ee7.png";